import { initializeApp } from "firebase/app";
import { firebaseConfig } from "./config";

export const app = initializeApp(firebaseConfig);
